module.exports = __webpack_public_path__ + "static/media/storage.71ac0cb4.svg";